import React, { useMemo } from 'react'
import { PREFERENCES } from '../../user/constants'

import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import {
  useRoadClosuresFetch,
  useAgenciesFetch,
} from '../../roadClosures/hooks'

import UserPanel from '../../user/components/UserPanel'
import SearchPanel from '../../search/components/SearchPanel'
import ClosuresPanel from '../../roadClosures/components/ClosuresPanel'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import RoadClosuresLayer from '../../map/components/RoadClosuresLayer'
import RoadsLayer from '../../map/components/RoadsLayer'
import AddressSearchLayer from '../../map/components/AddressSearchLayer'

import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'
import MapDataToggle from '../../mobile/components/MapDataToggle'
import MobileSidebar from '../../mobile/components/MobileSidebar'
import MobileBaseLayout from '../../mobile/components/MobileBaseLayout'
import MobileSiteSwitcher from '../../mobile/components/MobileSiteSwitcher'

const tabs = [
  {
    name: 'User Options',
    icon: 'fa fa-user',
    url: '/roadClosures/userMenu',
  },
  {
    name: 'Closure List',
    icon: 'fa fa-list-ul',
    url: '/roadClosures/closureList',
  },
  {
    name: 'Address Search',
    icon: 'fa fa-search',
    url: '/roadClosures/search',
  },
]

const MobileLayout = () => {
  useUserPreferencesFetch() // fetch user's preferences
  useRoadClosuresFetch()
  useAgenciesFetch()

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      bottom: 75,
    }),
    []
  )

  return (
    <MobileBaseLayout title="Road Closures" basePath="/roadClosures">
      <MobileSidebar basePath="/roadClosures">
        <TabPanelContainer>
          <TabPanel path="/roadClosures/menu">
            <MobileSiteSwitcher tabs={tabs} />
          </TabPanel>
          <TabPanel path="/roadClosures/userMenu" component={UserPanel} />
          <TabPanel
            path="/roadClosures/closureList"
            component={ClosuresPanel}
          />
          <TabPanel path="/roadClosures/search" component={SearchPanel} />
        </TabPanelContainer>
      </MobileSidebar>
      <MapDataToggle
        mapPath="/roadClosures/"
        listPath="/roadClosures/closureList"
      />
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Zoom position="none" />
        <RoadsLayer />
        <RoadClosuresLayer />
        <AddressSearchLayer />
      </Map>
    </MobileBaseLayout>
  )
}

export default MobileLayout
